import React, { Component } from "react";
import { req_list_cslc_public_works_end } from "../api";
import { DEFAULT_IMAGE_URL } from "../utils/contrains";
import { Card, Tag, List, Image, Collapse } from "antd";

import image from './assets/images/littlebobo.jpg'

const { Panel } = Collapse;
export default class ViewAward extends Component {
    state = {
        loading: false,
        workitems: [],
        item: {},
        enrollCode: "",
        startVoting: false /* VOTE_PROGRESS */,
        voteStatus: "CLOSE" /* CLOSE/VOTE_NOTBEGIN/VOTE_END */,
        voteActivity: "2022-1001-00001",
        data: [
            {
                title: '第一名',
                content: [
                    {
                        price: '',
                        space: '南應大「數位形象專屬設計師委託合約」',
                        user: '獎狀乙幀',
                        support: '計1名',
                    }
                ]
            },
            {
                title: '第二名',
                content: [
                    {
                        price: '獎金3,000元',
                        space: 'LINE貼圖上架授權',
                        user: '獎狀乙幀',
                        support: '計1名',
                    }
                ]
            },
            {
                title: '第三名',
                content: [
                    {
                        price: '獎金2,000元',
                        space: 'LINE貼圖上架授權',
                        user: '獎狀乙幀',
                        support: '計1名',
                    }
                ]
            },
            {
                title: '第四名',
                content: [
                    {
                        price: '獎金1,500元',
                        space: 'LINE貼圖上架授權',
                        user: '獎狀乙幀',
                        support: '計1名',
                    }
                ]
            },
            {
                title: '第五名',
                content: [
                    {
                        price: '獎金1,000元',
                        space: 'LINE貼圖上架授權',
                        user: '獎狀乙幀',
                        support: '計1名',
                    }
                ]
            },
        ]
    }

    UNSAFE_componentWillMount() {
        this.api_list_workitems();
    }

    api_list_workitems = async () => {

        this.setState({ loading: true, workitems: [] });
        const result = await req_list_cslc_public_works_end();
        this.setState({ loading: false });

        //console.log(result)
        if (result.total > 0) {
            const { data } = result;
            const workitems = data.slice(0, 8);

            this.setState({ workitems });
            //console.log(items);
        } else {
            const workitems = [];
            this.setState({ workitems });
        }
    };

    style_switch_color_tag(column, type) {
        let ans = "black";
        switch (type) {
            case "awardlevel":
                switch (column) {
                    case 0:
                        ans = "#FDC904";
                        break;
                    case 1:
                        ans = "#9a9a9a";
                        break;
                    case 2:
                        ans = "#8E3F07";
                        break;
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                        ans = "#D9FC96";
                        break;
                    default:
                        // OTHER
                        ans = "	White";
                        break;
                }
                break;
            default:
                ans = "black";
                break;
        }
        return ans;
    }

    render() {
        const { loading, data, workitems } = this.state;
        return (
            <>
                <div id="award" className="block awardBlock bgGray">
                    <div className="container-fluid">
                        <div className="titleHolder">
                            <h2><img alt="bobo" src={image} width="60px" height="40px" />徵稿獎勵</h2>
                        </div>
                        <List
                            grid={{
                                gutter: 16,
                                xs: 1,
                                sm: 1,
                                md: 5,
                                lg: 5,
                                xl: 5,
                                xxl: 5
                            }}
                            dataSource={data}
                            renderItem={item => (
                                <List.Item>
                                    <Card title={item.title}>
                                        <p><span className="large">{item.content[0].price}</span></p>
                                        <p>{item.content[0].space}</p>
                                        <p>{item.content[0].user}</p>
                                        <p>{item.content[0].support}</p>
                                        {/* <Button type="primary" size="large" disable>獲獎作品</Button> */}
                                    </Card>
                                </List.Item>
                            )}
                        />
                        <div className='meno'>另佳作（3名）：獎金500元、獎狀</div>
                        <div className='alert'>※得獎名次得從缺。</div>
                        {loading ? (
                            <div >
                                <div className="text-center">
                                    <button
                                        className="btn btn-light text-dark"
                                        type="button"
                                        disabled
                                    >
                                        <span
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                        ></span>{" "}
                                        查詢中 ......
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <>
                                {workitems.length > 0 ? (
                                    <>
                                        {" "}
                                        <div className="container">
                                            <div className="row">
                                                {workitems.map((item, index) => {
                                                    return (
                                                        <div
                                                            className="col-md-3"
                                                            key={index}
                                                            style={{ marginBottom: "6px" }}
                                                        >
                                                            <div className="thumbnail colstyle" key={index}>
                                                                <div className="caption">
                                                                    <Collapse accordion defaultActiveKey={["1"]}>
                                                                        <Panel header={<span>
                                                                            {" "}
                                                                            編號：
                                                                            <strong
                                                                            >
                                                                                {item.WorksCode}{" "}
                                                                            </strong>
                                                                            / 作者：
                                                                            <strong
                                                                                style={{
                                                                                    color: "purple",
                                                                                }}
                                                                            >
                                                                                {item.EnrollName}{" "}
                                                                            </strong>
                                                                        </span>} key="1">
                                                                            <div
                                                                                style={{
                                                                                    textAlign: "center",

                                                                                }}
                                                                            >
                                                                                {index < 3 ? <i
                                                                                    className="fas fa-award"
                                                                                    style={{
                                                                                        color: this.style_switch_color_tag(
                                                                                            index,
                                                                                            "awardlevel"
                                                                                        ),
                                                                                        fontSize: "1.6em",
                                                                                    }}
                                                                                ></i> : ""}

                                                                                <strong style={{ fontSize: "1.4em", padding: "4px", color: index < 5 ? "red" : "green" }}>{item.Ranking}</strong>
                                                                                <br />
                                                                            </div>
                                                                        </Panel>
                                                                    </Collapse>
                                                                </div>
                                                                <div style={{ textAlign: "center" }}>
                                                                    <Image
                                                                        width={"250px"}
                                                                        height={"150px"}
                                                                        src={DEFAULT_IMAGE_URL + item.AttachedfileA}
                                                                    />
                                                                </div>
                                                            </div>

                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <div style={{ textAlign: "center" }}>
                                        <Tag color="gray" style={{ margin: "10px" }}>
                                            尚無入選作品
                                        </Tag>
                                    </div>
                                )}
                            </>
                        )}
                        <div>
                            <span>以上獎金皆含稅，須依稅法各類所得扣繳率標準第2、3條規定辦理：</span>
                            <ol>
                                <li>獲（中）獎人為國內居住者的個人，或在國內有固定營業場所的營利事業，其中獎的獎金或給與，按給付金額扣取10%。</li>
                                <li>獲（中）獎人為非國內居住者的個人，或在國內無固定營業場所的營利事業，一律按給付金額扣取20%</li>
                            </ol>
                        </div>

                    </div>
                </div>
                <p></p>

            </>
        )
    }
}